import { authApi } from '@/services/authApi';
import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
import type { AuthUser } from './AuthContext';
import { AuthContext } from './AuthContext';

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const restoreSession = useCallback(async (): Promise<void> => {
    try {
      const user = await authApi.me();
      if (user) {
        setUser(user);
      }
    } catch {
      // Session restore failed, user remains logged out
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    restoreSession();
  }, [restoreSession]);

  const login = (userData: AuthUser) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
  };

  const getOrganizationSlug = (): string | null => {
    if (user?.organizations && user.organizations.length > 0) {
      const slug = user.organizations[0].slug || null;
      return slug;
    }
    return null;
  };

  const value = {
    user,
    isAuthenticated: !!user,
    isLoading,
    login,
    logout,
    getOrganizationSlug,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
